module.exports = __webpack_public_path__ + "img/liantong.60f3c38a.jpg";